import { jsx as _jsx } from "react/jsx-runtime";
import iconSet from '../../assets/icon/selection.json';
const icons = iconSet;
function getIcon(icon, styles, size, className, rest) {
    const find = (ic) => ic.properties.name.split(', ').includes(icon);
    const currentIcon = icons.icons.find(find);
    const getPath = (item) => (path, index) => {
        const attrs = (item.attrs && item.attrs[index]) || {};
        return _jsx("path", { style: styles.path, d: path, ...attrs }, index);
    };
    if (currentIcon) {
        return (_jsx("svg", { className: className, style: styles.svg, width: size, height: size, viewBox: `0 0 ${currentIcon.icon.width || '1024'} 1024`, xmlns: "http://www.w3.org/2000/svg", ...rest, "data-testid": "icon", children: currentIcon.icon.paths.map(getPath(currentIcon.icon)) }));
    }
    return null;
}
const Icon = (props) => {
    const { color, size = '24px', icon, className = '', style = {}, ...rest } = props;
    const styles = {
        svg: {
            display: 'inline-block',
            verticalAlign: 'middle',
            ...style,
        },
        path: {
            fill: color || 'currentColor',
        },
    };
    return getIcon(icon, styles, size, className, rest);
};
export default Icon;
